// extracted by mini-css-extract-plugin
export var aircallIframe = "_g1-3";
export var fabContainer = "_g1-5";
export var fabRinging = "_g1-6";
export var loadingOverlay = "_g1-4";
export var pulse = "_g1-7";
export var widgetContent = "_g1-2";
export var widgetPanel = "_g1-0";
export var widgetPanelExpanded = "_g1-1";